import React, {useEffect} from "react"
import {Link} from "react-router-dom"

import {ROUTE_PATHS} from "../utils/routes"
import AnalyticsService from "../utils/AnalyticsService"
import {Button} from "../components/styled"

export const ContactSuccess = () => {
  useEffect(()=>{
    AnalyticsService.sendUniquePageview(ROUTE_PATHS.CONTACT_SUCCESS);
  });
  return (
    <section>
      <div className="container hero3">
        <div className="row no-gutters2">
          <div className="col-md-12 mb-4">
            <h1 className="magenta">Thank You!</h1>
            <p>Your email has been sent</p>
            <div>
              <Link to={ROUTE_PATHS.HOME}><Button primary style={{cursor: "pointer"}}>Return Home</Button></Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
